/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const PAGE_LOAD_TABLE_STRINGS = {
  bandwidth: 'Bandwidth',
  heading: '50 slowest loading pages',
  p95Time: 'P95 time',
  pageLoadTime: 'Page load time',
  requests: 'Requests',
} as const;
